import { useAppStore } from "@/composables";
import { getLocalizationObject, getUserSettingsForRouter } from "@/router/helpers";
import { LanguageCode2DefaultCurrencyIdMap, LanguageId2CountryCodeMap, setCountry } from "@/services/translation";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

export const setUserPreferredLocalization = async (route: RouteLocationNormalized, _: RouteLocationNormalized, next: NavigationGuardNext) => {
  const localization = getLocalizationObject(route);
  if (localization === undefined) {
    throw new Error("DEV: Should not happen. Some beforeEach() guard which checks localization in URL should be called prior this guard.");
  }
  const userSettings = await getUserSettingsForRouter();
  if (userSettings !== undefined) {
    const userPreferredLanguageId = userSettings.displayLanguageId;
    const userPreferredCountry = LanguageId2CountryCodeMap[userPreferredLanguageId];

    // Use await here, because we want to wait until translations file is loaded.
    await setCountry(userPreferredCountry);

    if (localization.country !== userPreferredCountry) {
      const routeWithPreferredCountry = {
        ...route,
        params: {
          ...route.params,
          countryCode: userPreferredCountry,
        },
      };
      return next(routeWithPreferredCountry);
    }
  } else {
    const preferredCurrencyId = LanguageCode2DefaultCurrencyIdMap[localization.language];
    useAppStore().setCurrencyId(preferredCurrencyId);
  }

  return next();
};
